import { Component, ElementRef, EventEmitter, HostListener, Inject, Input, Output, ViewChild } from '@angular/core';
import { TelemetryDimensionDto } from '@shared/src/controllers/maintenance/device/telemetry/TelemetryDimensionDto';
import { TelemetryDto } from '@shared/src/controllers/maintenance/device/telemetry/TelemetryDto';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { HDateHour } from '../../../../../src/datatypes/HDateHour';


export interface PeriodicElement {
    moment: HDateHour;
    latitude: number;
    longitude: number;
    altitude: number;
    temperature: number;
    action: string;
}

const ELEMENT_DATA: PeriodicElement[] = [];
const ELEMENT_DATA_DIMENSION: PeriodicElement[] = [];

/**
 * @title Styling columns using their auto-generated column names
 */
@Component({
    selector: 'shared-telemetry-table',
    styleUrls: ['shared.telemetry.table.scss'],
    templateUrl: 'shared.telemetry.table.html',
})
export class SharedTelemetryTable {

    public showTelemetry: boolean = false;
    public showDimensions: boolean = false;

    private _listTelemetry: Array<TelemetryDto>;

    @Input() public set listTelemetry(value: Array<TelemetryDto>) {
        if (value) {
            this._listTelemetry = value;
            this.showTelemetry = true;
        } else {
            this._listTelemetry = [];
            this.showTelemetry = false;
        }

    }
    public get listTelemetry(): Array<TelemetryDto> {
        return this._listTelemetry;
    }

    public dimensionNames: Array<String> = [];
    public listDimensionProcessat: Map<number, Map<string, TelemetryDimensionDto>> = new Map<number, Map<string, TelemetryDimensionDto>>();
    private _listDimension: Map<number, Array<TelemetryDimensionDto>>;
    @Input()
    public set listDimension(value: Map<number, Array<TelemetryDimensionDto>>) {
        if (value) {
            this.showDimensions = true;
            for (let item of Object.entries(value)) {
                item[1].forEach((dimension: TelemetryDimensionDto) => {
                    if (!this.dimensionNames.includes(dimension.dimension))
                        this.dimensionNames.push(dimension.dimension);

                    if (!this.listDimensionProcessat.get(parseInt(item[0])))
                        this.listDimensionProcessat.set(parseInt(item[0]), new Map<string, TelemetryDimensionDto>());

                    if (!this.listDimensionProcessat.get(parseInt(item[0])).get(dimension.dimension)) {
                        this.listDimensionProcessat.get(parseInt(item[0])).set(dimension.dimension, dimension);
                    }
                })
            }
        } else {
            this.showDimensions = false;
            this._listDimension = new Map();
            this.listDimensionProcessat = new Map();
            this.dimensionNames = [];

        }
    }

    public get listDimension(): Map<number, Array<TelemetryDimensionDto>> {
        return this._listDimension;
    }

    @Input()
    public resultType: string;

    @Input()
    public dimensionName: string;

    private _selectedTelemetry: any;
    @Input() public set selectedTelemetry(value: any) {
        if (value === this._selectedTelemetry)
            return;
        this._selectedTelemetry = value;
    }
    public get selectedTelemetry(): any {
        return this._selectedTelemetry;
    }


    @Output() markerUpdate = new EventEmitter();
    public onMarkerClick(telemetryId: any) {
        if (this.listTelemetry) {
            this.listTelemetry.forEach((item: TelemetryDto) => {
                if (item.telemetryId == telemetryId) {
                    this.selectedTelemetry = item;
                    this.markerUpdate.emit(item);
                }
            })
        }
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }

    public getValueType(telemetryId: number, str: any) {
        if (this.listDimensionProcessat) {
            if (this.listDimensionProcessat.get(telemetryId) && this.listDimensionProcessat.get(telemetryId).get(str)) {
                let value = this.listDimensionProcessat.get(telemetryId).get(str).value;
                if (typeof value == "number" || (!isNaN(+value) && !isNaN(parseFloat(value))))
                    return "number";
                if (typeof value == "string")
                    return "string";
            }
        }
        return ""
    }


    public getDimensionValue(telemetryId: number, str: any) {
        if (this.listDimensionProcessat) {
            if (this.listDimensionProcessat.has(telemetryId)) {
                if (this.listDimensionProcessat.get(telemetryId).has(str)) {
                    return this.listDimensionProcessat.get(telemetryId).get(str).value;
                }
            }
        }
        return ""
    }

    public getMoment(telemetryId: number): HDateHour {
        if (this.listDimensionProcessat) {
            if (this.listDimensionProcessat.has(telemetryId)) {
                for (let item of this.listDimensionProcessat.get(telemetryId)) {
                    return item[1].moment;
                }
            }
        }
        return null
    }

    getShowScrollBottom() {
        this.onScrollBottom();
        return (this.scrollHeight > this.parentHeight && this.parentScrollTop >= 0 && (this.scrollHeight - this.parentHeight) > this.parentScrollTop);
    }

    getShowScrollTop() {
        this.onScrollTop();
        return (this.scrollHeight > this.parentHeight && this.parentScrollTop != 0);
    }

    @ViewChild("container", { read: ElementRef, static: false }) container: ElementRef;
    public scrollHeight = 0;
    public parentHeight = 0;
    public parentScrollTop = 0;

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.onScrollBottom();
    }
    @HostListener("window:scroll", ['$event'])
    doSomethingOnInternalScroll($event: Event) {
        this.onScrollBottom();
    }
    public onScrollBottom() {
        if (this.container != null && this.container.nativeElement != null) {
            this.scrollHeight = this.container.nativeElement.scrollHeight;
            if (this.container.nativeElement.parentElement != null) {
                this.parentHeight = this.container.nativeElement.parentElement.clientHeight;
                this.parentScrollTop = this.container.nativeElement.parentElement.scrollTop;
            }
        }
    }

    public onScrollTop() {
        if (this.container != null && this.container.nativeElement != null) {
            this.scrollHeight = this.container.nativeElement.scrollHeight;
            if (this.container.nativeElement.parentElement != null) {
                this.parentHeight = this.container.nativeElement.parentElement.clientHeight;
                this.parentScrollTop = this.container.nativeElement.parentElement.scrollTop;
            }
        }
    }

    public goScrollBottom() {
        if (this.container != null && this.container.nativeElement != null) {
            if (this.container.nativeElement.parentElement != null) {
                this.container.nativeElement.parentElement.scroll({
                    top: this.container.nativeElement.scrollHeight,
                    behavior: 'smooth'
                });
            }
        }
    }

    public goScrollTop() {
        if (this.container != null && this.container.nativeElement != null) {
            if (this.container.nativeElement.parentElement != null) {
                this.container.nativeElement.parentElement.scroll({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }
    }


}